/*
order form
AT
10.03.23
*/

import OrderForm from './order-form.svelte'

const
orderForm = new OrderForm({
	target: document.querySelector('#order-form'),
	props: { }
})

export default { orderForm }